/* Update these constants to turn 3mc on and off and to move to new year version.
   "versionLastYear" should be one less than the year of this version.  For instance
   for a 2025 version, "versionLastYear" should be 2024. */
export const _3mc_On = false;
export const versionLastYear = 2024;

export const all = 0;

export const varName = 0;
export const currID1 = 1;
export const currID2 = 2;

export const countryCodeBotswana = 72;
export const countryCodeEthiopia = 231;
export const countryCodeKenya = 404;
export const countryCodeLesotho = 426;
export const countryCodeMalawi = 454;
export const countryCodeMozambique = 508;
export const countryCodeNamibia = 516;
export const countryCodeSouthAfrica1 = 710;
export const countryCodeSouthAfrica2 = 711; // FALSE BUT NEEDED
export const countryCodeSouthAfrica3 = 712; // FALSE BUT NEEDED
export const countryCodeSouthAfrica4 = 713; // FALSE BUT NEEDED
export const countryCodeeSwatini = 748;
export const countryCodeTanzania = 834;
export const countryCodeUganda = 800;
export const countryCodeZimbabwe1 = 716;
export const countryCodeZimbabwe2 = 717; // FALSE BUT NEEDED
export const countryCodeZambia = 894;
export const countryCodeRwanda = 646;
export const countryCodeSampleCountry = 5833; // should actually be 5733, but takes coordination to change...
export const countryCodeCrossCountry = 9999;
export const countryUseRegions = [
    countryCodeBotswana,
    countryCodeZambia,
    countryCodeLesotho,
    countryCodeeSwatini,
    countryCodeMalawi,
    countryCodeTanzania,
    countryCodeUganda,
];

/* Page IDs */
export const DMResultsFormPg = "DMResultsForm";
export const DMWelcomeFormPg = "DMWelcomeForm";
export const DMDashboardFormPg = "DMDashboardForm";
export const DMTargVsPriorAchievFormPg = "DMTargVsPriorAchievForm";
export const DMProgCovByAgeGroupFormPg = "DMProgCovByAgeGroupForm";
export const DMProgCovBySNUFormPg = "DMProgCovBySNUForm";
export const DMCovByAgeSNUFormPg = "DMCovByAgeSNUForm";
export const DMImpactHIVInfAvertedFormPg = "DMImpactHIVInfAvertedForm";
export const DMVMMCsReqPerHIVInfAvertedFormPg = "DMVMMCsReqPerHIVInfAvertedForm";
export const DMProgCovByCountryFormPg = "DMProgCovByCountry";
export const DMCovTableByAgeCountryFormPg = "DMCovTableByAgeCountryForm";
export const DMAPA1FormPg = "DMAPA1Form";
export const DMAPA2FormPg = "DMAPA2FormForm";
export const DMAPA3IncrCovFormPg = "DMAPA3IncrCovForm";
export const DMAPA123FormPg = "DMAPA123Form";
export const DMAPA3UptakeRateByCountryFormPg = "DMAPA3UptakeRateByCountryForm";
export const DMMalePopByAgeGroupFormPg = "DMMalePopByAgeGroupForm";
export const DMCoverageFormPg = "DMCoverageForm";

export const noData = -1;

/* Navigation combobox option current IDs */

export const introOp = 1;
export const countryDashOp = 2;
export const targCovBySNUOp = 3;
export const targPriorAchOp = 4;
export const progCovByAgeGroupOp = 5;
export const progCovBySNUOp = 6;
export const covTableByAgeSNUOp = 7;
export const impactHIVInfectAvertOp = 8;
export const impactVMMCsReqOp = 9;
export const progCovByCountryOp = 10;
export const covTableByAgeCountryOp = 11;
export const agePriorAnal1Op = 12;
export const agePriorAnal2Op = 13;
export const agePriorAnal3Op = 14;
export const agePriorAnalOp = 15;
export const agePriorAnal3UptakeCountryOp = 16;
export const circumPopsByAgeGroupOp = 17;
export const numNavOptions = circumPopsByAgeGroupOp;

/* VMMC age groups */

export const ageEIMC_CurrID = 1;
export const age10t14CurrID = 2;
export const age15t19CurrID = 3;
export const age20t24CurrID = 4;
export const age25t29CurrID = 5;
export const age30t34CurrID = 6;
export const age35t39CurrID = 7;
export const age40t44CurrID = 8;
export const age45t49CurrID = 9;
export const age50t54CurrID = 10;
export const age55t59CurrID = 11;
export const numVMMC_AgeGroups = age55t59CurrID;

// Replace with above (or better yet, replace with same ones SC uses, if possible), when
// time allows

export const DP_AllAges = 0;
export const DP_A0_4 = 1;
export const DP_Infant = 1;
export const DP_A5_9 = 2;
export const DP_A10_14 = 3;
export const DP_A15_19 = 4;
export const DP_A20_24 = 5;
export const DP_A25_29 = 6;
export const DP_A30_34 = 7;
export const DP_A35_39 = 8;
export const DP_A40_44 = 9;
export const DP_A45_49 = 10;
export const DP_A50_54 = 11;
export const DP_A55_59 = 12;
export const DP_A60_64 = 13;
export const DP_A65_69 = 14;
export const DP_A15_29 = 13;
export const DP_A10_29 = 14;
export const DP_A30Plus = 7;
export const DP_A70_74 = 15;
export const DP_A75_79 = 16;
export const DP_A80_Up = 17;
export const DP_MAX_AGE = 17;

/* Target year */
export const firstYear = 2000;
export const firstPossibleTargetYear = 2018; // new Date().getFullYear()+0;
export const lastYearProgData = versionLastYear;
export const defaultTargetYear = lastYearProgData + 2;
export const defaultFinalDisplayYear = 2040;
export const lastPossibleTargetYear = 2050;

/* Fiscal year start (FYS) [month] */
export const janFYS = 1;
export const aprFYS = 2;
export const julyFYS = 3;
export const octFYS = 4;
export const numFYS = octFYS;

/* countryObjList fields */
export const countryObjMstID = "mstID";
export const countryObjName = "name";

export const baseCoverage = 1;
export const targetCoverage = 2;

export const showChart = 1;
export const showTable = 2;

/* Results fields */
export const rResult1 = "Result1";
export const rResult2 = "Result2";
export const rResult3 = "Result3";
export const rResult4 = "Result4";
export const rResult5 = "Result5";
export const rResult6 = "Result6";
export const rResult7 = "Result7";
export const rResult8 = "Result8";
export const rResult9 = "Result9";
export const rResult10 = "Result10";
export const rResult11 = "Result11";
export const rResult12 = "Result12";
export const rResult13 = "Result13";
export const rResult14 = "Result14";
export const rResult15 = "Result15";
export const rResult16 = "Result16";
export const rPointLabels = "PointLabels";
export const rSubsetLabels = "SubSetLabels";
export const rData = "data";
export const rData1 = "data1";
export const rData2 = "data2";
export const rData3 = "data3";
export const rData4 = "data4";
export const rNote = "note";
export const rPoints = "points";
export const rSubsets = "subsets";
export const rTitle = "title";
export const rValid = "valid";
export const rXAxisTitle = "xAxisTitle";
export const rYAxisTitle = "yAxisTitle";
export const rYAxisLabel = "yAxisLabel";

/* Inputs fields */
export const rInputs = "Inputs";
export const rSurveyYearIdx = "SurveyYearIdx";
export const rFirstYearMCIdx = "FirstYearMCIdx";

export const coverageTarget = 90;
